import { useQuery } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';
import { useAppSettingsStore } from '@/shared/lib';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import { getBankDepositCountriesRequest } from '../requests';
import type { BankDepositCountriesResponse } from '../types';

export function useBankDepositCountries(enabled = true) {
  const { session } = useSessionStore();
  const { getLanguage } = useAppSettingsStore();
  const locale = getLanguage();

  const query = useQuery<BankDepositCountriesResponse, Error>({
    queryKey: ['bankDepositCountries', session?.userId, locale],
    queryFn: getBankDepositCountriesRequest,
    enabled,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    retry: 1,
  });

  return {
    countries: query.data?.countries ?? [],
    isCountriesLoading: query.isLoading,
    isCountriesFetching: query.isFetching,
    isCountriesError: query.isError,
    countriesError: query.error,
  };
}
